import React, {useContext} from 'react'
import { Row, Col  } from "antd";
import { ContainerOutlined } from '@ant-design/icons';
import { AppContext } from '../../util/context';
import { ReviewInsights } from './Hazard/ReviewInsights';

export const ReviewMenu = ({current, setCurrent, data}) => {
    const {
        StyledDiv
    } = useContext(AppContext);
    return (
        <>
            <Row
                className={"atMenuNoRep"}
            >
                <Col
                    xl={{span: 3}}
                    lg={{span: 6}}
                    md={{span: 6}}
                    sm={{span: 12}}
                    xs={{span: 12}}
                    style={{
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "start",
                        padding: "10px",
                    }}
                >
                    <div
                        className="atMenuContainer"
                        style={{
                            display: "flex",
                        }}
                        onClick={() => {
                            setCurrent("allcards")
                        }}
                    >
                        <ContainerOutlined className={current === "allcards" ? "atMenuIconSelected" : "atMenuIcon"} />
                        <StyledDiv
                            className={current === "allcards" ? "atMenuTextSelected" : "atMenuText"}
                        >
                            ALL CARDS
                        </StyledDiv>
                    </div>
                </Col>

                <Col
                    xl={{span: 3}}
                    lg={{span: 6}}
                    md={{span: 6}}
                    sm={{span: 12}}
                    xs={{span: 12}}
                    style={{
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "start",
                        padding: "10px",
                    }}
                >
                    <div
                        className="atMenuContainer"
                        style={{
                            display: "flex",
                        }}
                        onClick={() => {
                            setCurrent("allactions")
                        }}
                    >
                        <ContainerOutlined className={current === "allactions" ? "atMenuIconSelected" : "atMenuIcon"} />
                        <StyledDiv
                            className={current === "allactions" ? "atMenuTextSelected" : "atMenuText"}
                        >
                            ALL ACTIONS
                        </StyledDiv>
                    </div>
                </Col>

                <Col
                    xl={{span: 18}}
                    lg={{span: 12}}
                    md={{span: 12}}
                    sm={{span: 0}}
                    xs={{span: 0}}
                    className="columnContainer"
                    /* style={{
                        padding: "10px"
                    }} */
                    
                >
                    <ReviewInsights data={data} tab={current} />
                </Col>
            </Row>
        </>
    )
}
